var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdministratorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 6,
    fill: "none",
    viewBox: "0 0 5 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.999 1.475a.235.235 0 0 0-.121-.205L2.61.029a.225.225 0 0 0-.22 0L.122 1.269a.235.235 0 0 0-.12.206C-.033 3.23.691 5.302 2.41 5.982a.224.224 0 0 0 .178 0C4.308 5.302 5.032 3.23 5 1.475zM2.27 5.401C1.39 4.922.938 4.041.705 3.234h1.566v2.167zm0-2.635H.59a6.644 6.644 0 0 1-.13-1.15l1.81-.99v2.14zM2.729 5.4V3.234h1.566c-.233.806-.687 1.688-1.566 2.167zm1.68-2.635H2.73V.626l1.81.99c-.004.211-.026.642-.13 1.15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministratorIcon);
export default __webpack_public_path__ + "static/media/administrator_icon.e2549db7feef2124b84063c97b729f32.svg";
export { ForwardRef as ReactComponent };